import { render, staticRenderFns } from "./MfaSettings.vue?vue&type=template&id=2cb1d84a&"
import script from "./MfaSettings.vue?vue&type=script&lang=js&"
export * from "./MfaSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports